import script from "./NotesHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotesHeader.vue?vue&type=script&setup=true&lang=ts"

import "./NotesHeader.vue?vue&type=style&index=0&id=334181ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334181ac"]])

export default __exports__